module.exports = __webpack_public_path__ + "img/job-hover.bab11547.svg";